import { render, staticRenderFns } from "./Item2ColIconEl.vue?vue&type=template&id=835c26ce&scoped=true&"
import script from "./Item2ColIconEl.vue?vue&type=script&lang=ts&"
export * from "./Item2ColIconEl.vue?vue&type=script&lang=ts&"
import style0 from "./Item2ColIconEl.vue?vue&type=style&index=0&id=835c26ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835c26ce",
  null
  
)

export default component.exports